export default __webpack_public_path__ + "static/media/Group -4.90c63d58.png";